import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setPopupState, setSnackbarMessage } from '../../model/configuratorSlice';
import { CloseButton, ContentCopy } from '../../shared/svg/components';
import { PopupState, FeedbackMessages } from '../../model/constants';
import { TranslationUtility } from '../../utilities/TranslationUtility';

const SaveConfigPopup = () => {
  const currentConfigCode = useSelector(state => state.configurator.currentConfigCode);
  const dispatch = useDispatch();

  const copyToClipboard = () => {
    const copyText = document.getElementById('input-code');
    navigator.clipboard.writeText(currentConfigCode);
    dispatch(setSnackbarMessage(FeedbackMessages.CodeCopiedToClipboard));
  };

  const closePopupHandler = () => {
    dispatch(setPopupState(PopupState.None));
  };

  useEffect(() => {

  }, [currentConfigCode]);

  const isSaveConfigPopupOpened = true;

  return (
    <div className={`save-config-popup ${isSaveConfigPopupOpened ? ' opened' : ''}`}>
      {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
      <button
        className={`background ${isSaveConfigPopupOpened ? 'opened' : ''}`}
        type="button"
        onClick={closePopupHandler}
      />
      <div className={`panel${isSaveConfigPopupOpened ? ' opened' : ''}`}>
        <div className="header">
          {TranslationUtility.GetFormattedMessageForUI('ui-save-panel-title', 'Configuración Guardada')}
        </div>
        <div className="sub-header">
          {TranslationUtility.GetFormattedMessageForUI('ui-save-panel-subtitle',
              'Usa este ShortCode para cargar tu diseño.')}
        </div>
        <div className="container-form-copy">
          <form className="form">
            <input
              name="code"
              type="text"
              id="input-code"
              className="input"
              placeholder={currentConfigCode}
              defaultValue={currentConfigCode}
            />
          </form>
          <button
            className="copy-button"
            type="button"
            alt="Copiar código"
            onClick={copyToClipboard}
          ><ContentCopy />
          </button>
        </div>
        <button
          type="button"
          className="close-button"
          onClick={closePopupHandler}
        >
          <CloseButton />
        </button>
      </div>
    </div>
  );
};

export default SaveConfigPopup;
